export default "__VITE_ASSET__CgdNvWBM__"